import { UserVarServer, VarExtraType, VarType } from 'shared/entities/vars';
import { FileBaseServer } from 'shared/entities/file';
import { UserItemModel } from 'shared/models/users';
import { IRootStore } from 'shared/entities/store/rootStore';

import UserAttachmentVarModel from './UserAttachmentVarModel';
import UserCommonVarModel from './UserCommonVarModel';
import UserDateVarModel from './UserDateVarModel';

export type UserVarModelType =
  | UserCommonVarModel
  | UserAttachmentVarModel
  | UserDateVarModel;

/**
 * Собирает модель переменной пользователя по типу, объявленному в проекте:
 * в ответе `users/get_user_vars` типа нет, он берётся из `variablesStore`.
 */
export const createUserVarModel = ({
  raw,
  type,
  chatId,
  user,
  rootStore
}: {
  raw: UserVarServer;
  /** Спец-переменные могут иметь временный тип — он попадает в общую ветку */
  type: VarExtraType;
  chatId: string;
  user: UserItemModel;
  rootStore: IRootStore;
}): UserVarModelType => {
  switch (type) {
    case VarType.date:
    case VarType.datetime:
      return UserDateVarModel.fromJson({
        value: raw.value as string | null,
        key: raw.key,
        chatId,
        user,
        rootStore,
        type
      });

    case VarType.attachment:
      return UserAttachmentVarModel.fromJson({
        key: raw.key,
        value: raw.value as FileBaseServer | null
      });

    default:
      return UserCommonVarModel.fromJson({
        value: raw.value as string,
        key: raw.key,
        chatId,
        user,
        rootStore
      });
  }
};
